export const SelectArray = [
    "Active",
    "Deactive",
    "Pending",
]

export const titleOptions = [
    {value: "", title: "N.A" },
    { value: "Dr", title: "Dr" },
    { value: "Dt", title: "Dt" },
    { value: "Dr(Pt)", title: "Dr(Pt)" },
    { value: "Mr", title: "Mr" },
    { value: "Mrs", title: "Mrs" }
];

  export const LanguageArray = [
    { label: "English", value: "English" },
    { label: "Hindi", value: "Hindi" },
    { label: "Bengali", value: "Bengali" },
    { label: "Telugu", value: "Telugu" },
    { label: "Marathi", value: "Marathi" },
    { label: "Tamil", value: "Tamil" },
    { label: "Urdu", value: "Urdu" },
    { label: "Gujarati", value: "Gujarati" },
    { label: "Malayalam", value: "Malayalam" },
    { label: "Kannada", value: "Kannada" },
    { label: "Odia", value: "Odia" },
    { label: "Punjabi", value: "Punjabi" },
    { label: "Assamese", value: "Assamese" },
    { label: "Maithili", value: "Maithili" },
    { label: "Sanskrit", value: "Sanskrit" },
    { label: "Konkani", value: "Konkani" },
    { label: "Sindhi", value: "Sindhi" },
    { label: "Dogri", value: "Dogri" },
    { label: "Manipuri", value: "Manipuri" },
    { label: "Bodo", value: "Bodo" },
    { label: "Santhali", value: "Santhali" },
    { label: "Bhojpuri", value: "Bhojpuri" },
    { label: "Rajasthani", value: "Rajasthani" },
    { label: "Chhattisgarhi", value: "Chhattisgarhi" },
    { label: "Haryanvi", value: "Haryanvi" },
    { label: "Maggahi", value: "Maggahi" },
    { label: "Awadhi", value: "Awadhi" },
    { label: "Tulu", value: "Tulu" },
    { label: "Mizo", value: "Mizo" }
  ];


export const DaysArray  = [1, 2, 3, 4, 5, 6, 7, 12, 15, 30]